module.exports = __webpack_public_path__ + "static/media/writing.4f743eb4.svg";